module.exports = __webpack_public_path__ + "static/btn_FAQ-c615b717450e978caca193459e12c1fa.png";